import { render, staticRenderFns } from "./MySpinner.vue?vue&type=template&id=c1f182ba&scoped=true&"
import script from "./MySpinner.vue?vue&type=script&lang=js&"
export * from "./MySpinner.vue?vue&type=script&lang=js&"
import style0 from "./MySpinner.vue?vue&type=style&index=0&id=c1f182ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1f182ba",
  null
  
)

export default component.exports